// eventBus.js
import { ref } from 'vue';

const events = ref({});

export const EventBus = {
  $on(event, callback) {
    if (!events.value[event]) {
      events.value[event] = [];
    }
    events.value[event].push(callback);
  },
  
  $emit(event, data) {
    if (events.value[event]) {
      events.value[event].forEach(callback => callback(data));
    }
  },
  
  $off(event, callback) {
    if (events.value[event]) {
      if (callback) {
        events.value[event] = events.value[event].filter(cb => cb !== callback);
      } else {
        delete events.value[event];
      }
    }
  }
};